import { useEffect, useState } from 'react'

import { NextRouter, withRouter } from 'next/router'

import { Menu } from 'antd'

import useGetAllMenu from 'data/useGetAllMenu'

import cssMenu from 'layouts/containers/Public/MenuBar/MenuBar.module.scss'

const getInternalUrl = (url: string): string =>
  url.startsWith('/') ? url : `/${url}`

const getExternalUrl = (url: string): string => {
  const normalizedUrl = url.trim()

  return /^https?:\/\//i.test(normalizedUrl)
    ? normalizedUrl
    : `https://${normalizedUrl.replace(/^\/+/, '')}`
}

const createMenus = (menu, handleNavigate) => {
  if (menu.hide) {
    return null
  }

  if (menu.submenus) {
    return {
      label: menu.name,
      key: `submenus_${menu.id}`,
      children: menu.submenus.map((submenu) =>
        createMenus(submenu, handleNavigate),
      ),
    }
  }

  return {
    label: menu.name,
    key: menu.key,
    onClick: () => handleNavigate(menu),
  }
}

function MenuBar({
  router,
  mode,
  setOpen = () => {},
}: {
  router: NextRouter
  mode: 'vertical' | 'horizontal' | 'inline'
  setOpen?: any
}) {
  const [filteredMenu, setFilteredMenu] = useState([])
  const token =
    typeof window !== 'undefined' ? localStorage.getItem('access_token') : ''

  const { data: menuData = [], refetch } = useGetAllMenu({
    sorted: { initialValue: { sequence: false } },
  })

  const menus = menuData
    ?.map((d) => {
      if (d?.SubMenus.length > 0) {
        // Menu 1
        return {
          id: d?.id,
          key: `menu_${d?.id}`,
          name: d?.name,
          typeAction: d?.typeAction,
          url: d?.menuAction || '',
          parrent: d?.menuAction || '',
          submenus: d?.SubMenus?.map((s) => {
            // Render Menu 2
            if (s?.LastSubMenus?.length > 0) {
              return {
                id: s?.id,
                key: `submenu_${s?.id}`,
                name: s?.name,
                typeAction: s?.typeAction,
                parrent: s?.menuAction || '',
                url: s?.menuAction || '',
                submenus: s?.LastSubMenus?.map((x) => {
                  return {
                    id: x?.id,
                    key: `last_submenu_${x?.id}`,
                    name: x?.name,
                    typeAction: x?.typeAction,
                    url: x?.menuAction || '',
                  }
                }),
              }
            }

            // Render Menu 2
            return {
              id: s?.id,
              key: `submenu_${s?.id}`,
              name: s?.name,
              typeAction: s?.typeAction,
              url: s?.menuAction || '',
            }
          }),
        }
      }
      // Menu 1
      return {
        id: d?.id,
        key: `menu_${d?.id}`,
        name: d?.name,
        typeAction: d?.typeAction,
        parrent: d?.menuAction || '',
        url: d?.menuAction || '',
      }
    })
    .sort((a, b) => a.sequence - b.sequence)

  useEffect(() => {
    if (menus.length > 0) setFilteredMenu(menus)
  }, [menuData])

  useEffect(() => {
    refetch()
  }, [token])

  const handleNavigate = (menu) => {
    const url = menu?.url ?? menu?.parrent

    if (!url) return

    setOpen(false)

    if (menu.typeAction === 'url') {
      window.open(getExternalUrl(url), '_blank', 'noopener,noreferrer')
      return
    }

    const internalUrl = getInternalUrl(url)

    if (router.asPath === internalUrl) {
      router.reload()
      return
    }

    router.push(internalUrl)
  }

  const menuItems = [...filteredMenu].map((menu) =>
    createMenus(menu, handleNavigate),
  )

  {
    /* @ts-ignore */
  }
  const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
    console.log(keys)
  }

  return (
    <div id={cssMenu.container}>
      <Menu
        mode={mode}
        items={menuItems}
        forceSubMenuRender
        subMenuCloseDelay={0.5}
        onOpenChange={onOpenChange}
        // expandIcon={<RightOutlined />}
      />
      {/* {renderMenus(filteredMenu)} */}
      {/* </Menu> */}
    </div>
  )
}

export default withRouter(MenuBar)
